import { Components, Theme } from '@mui/material/styles'

export const paperTheme: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
    }),
    outlined: ({ theme }) => ({
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.action.hover : theme.palette.grey[100],
      color: theme.palette.text.primary,
    }),
  },
}
